import { render, staticRenderFns } from "./UserNewsDetails.vue?vue&type=template&id=62db8cdc&scoped=true&"
import script from "./UserNewsDetails.vue?vue&type=script&lang=js&"
export * from "./UserNewsDetails.vue?vue&type=script&lang=js&"
import style0 from "./UserNewsDetails.vue?vue&type=style&index=0&id=62db8cdc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62db8cdc",
  null
  
)

export default component.exports